import React from "react";
import ReliefText from "./reliefTurn.view";

const ReliefTextContainer = ({ onCancel, reliefText, read }) => {
  return (
    <>
      <ReliefText cancelAction={onCancel} observations={reliefText} />
    </>
  );
};

ReliefTextContainer.propTypes = {};

export default ReliefTextContainer;
